
import { ReportingResult } from "../Models/Reporting/ReportingResult";
import { ReportingWithIdModel } from "../Models/Reporting/ReportingWithIdModel";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class ReportingProvider {
    public provider: ReportingProvider | undefined;
    public init() {
        if (!this.provider) {
            this.provider = new ReportingProvider();
        }
    }

    public dataset(data: ReportingWithIdModel): Promise<RespondClient<ReportingResult>> {
        return getInstance().post(`${getApiHost()}/api/Reporting/schemas/dataset`, data);
    }

    public schemasTopModels(data: ReportingWithIdModel): Promise<RespondClient<ReportingResult>> {
        return getInstance().post(`${getApiHost()}/api/Reporting/schemas/top-models`, data);
    }

    public schemasCpu(data: ReportingWithIdModel): Promise<RespondClient<ReportingResult>> {
        return getInstance().post(`${getApiHost()}/api/Reporting/schemas/cpu`, data);
    }

    public modelCpu(data: ReportingWithIdModel): Promise<RespondClient<ReportingResult>> {
        return getInstance().post(`${getApiHost()}/api/Reporting/models/cpu`, data);
    }

    public modelUsage(data: ReportingWithIdModel): Promise<RespondClient<ReportingResult>> {
        return getInstance().post(`${getApiHost()}/api/Reporting/models/usage`, data);
    }

}

export const ReportingProviderInstance = new ReportingProvider();
